import React from 'react'
import {useTranslation} from "react-i18next"

import {IonButtons, IonItem, IonLabel} from "@ionic/react"

import PersonGroup from "../../../types/PersonGroup"
import Person      from "../../../types/Person"
import IconPerson from "../../common/Icons/Person";

import ListItemButtonDataSource from "../../common/Buttons/ListItemButtonDataSource"
import ListItemButtonAlertEmail from "../../People/ListItem/ButtonAlertEmail"
import ListItemButtonAlertPhone from "../../People/ListItem/ButtonAlertPhone"

interface props {
    personGroup:  PersonGroup;
    person:       Person;
}

const ListItem: React.FC<props> = ({personGroup, person}: props) => {

    const { t }          = useTranslation()
    const minButtonWidth: string = '50px';

    return (
        <IonItem className={person.isHidden ? 'hidden-by-default' : ''} lines="inset"
                 key={"personGroup-" + personGroup.id + '-person-' + person.id}
                 button detail routerLink={"/people/" + person.id + '/view'}>
            <IconPerson slot="start" />
            <IonLabel>
                {! person.firstName && ! person.lastName
                    ? <i>({t('common.no_name')})</i>
                    : person.firstName + ' ' + person.lastName }
                <p>
                    {person.companyName && <span style={{ 'fontWeight': 300 }}>{person.companyName}</span>}
                    {(person.companyName && person.email) && <span>&nbsp;-&nbsp;</span>}
                    <span>{person.email || <br />}</span>
                </p>
            </IonLabel>
            <IonButtons className="ion-hide-sm-down" slot="end">
                <div style={{ 'minWidth': minButtonWidth }}>
                    <ListItemButtonAlertPhone active={person.phone1 !== null && person.phone1 !== ''} />
                </div>
                <div style={{ 'minWidth': minButtonWidth }}>
                    <ListItemButtonAlertEmail active={person.email !== null && person.email !== ''} />
                </div>
                <div style={{ 'minWidth': minButtonWidth }}>
                    <ListItemButtonDataSource active={person?.dataSourceId !== null}
                                              itemType={t('people.title_item').toLowerCase()} />
                </div>
            </IonButtons>
        </IonItem>
    )
}

export default ListItem